import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSite } from "@/context/ThemeContext";
import { Reveal } from "@/components/Reveal";
import { getIcon } from "@/lib/icons";

export default function Courses() {
  const { data } = useSite();
  const navigate = useNavigate();
  if (!data) return null;
  const { categories, courses } = data;
  const count = (id) => courses.filter((c) => c.category === id).length;

  return (
    <div className="relative z-10 pt-28">
      <section className="mx-auto max-w-7xl px-5 py-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-primary-c">Courses</span>
          <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-t mt-4">
            Find Your <span className="text-primary-c">Path.</span>
          </h1>
          <p className="text-muted-c text-lg mt-5 max-w-2xl">Six categories. 18+ courses. Choose a track and start building your future.</p>
        </Reveal>

        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3 mt-12">
          {categories.map((cat, i) => {
            const Icon = getIcon(cat.icon);
            return (
              <Reveal key={cat.id} delay={(i % 3) * 0.08}>
                <button onClick={() => navigate(`/courses/${cat.id}`)}
                  className="glass card-hover rounded-2xl p-8 text-left w-full h-full flex flex-col" data-testid={`category-${cat.id}`}>
                  <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6" style={{ background: "rgba(var(--primary-rgb),0.12)" }}>
                    <Icon className="text-primary-c" size={28} />
                  </div>
                  <h3 className="font-display font-bold text-2xl text-t">{cat.name}</h3>
                  <span className="text-xs uppercase tracking-wide font-semibold text-primary-c mt-2">{count(cat.id)} Courses</span>
                  <p className="text-muted-c text-sm mt-3 flex-1">{cat.description}</p>
                  <span className="inline-flex items-center gap-1.5 text-primary-c font-semibold text-sm mt-5">Explore <ArrowRight size={15} /></span>
                </button>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}
